export default "__VITE_ASSET__BkwRIeBM__"